import ResetQuantity from "../symbols/resetQuantity";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

function ResetQuantityReducer(state = initialState, action: any) {
  switch (action.type) {
    case ResetQuantity.RESET_QUANTITY:
      return { ...state, loading: true, error: false };
    case ResetQuantity.RESET_QUANTITY_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case ResetQuantity.RESET_QUANTITY_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case ResetQuantity.CLEAR_RESET_QUANTITY:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default ResetQuantityReducer;
